import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import UserContext from '../../App/Contexts/UserContext';
import MobileUtil from '../../Util/MobileUtil';
import AppMenu from '../AppMenu/AppMenu';
import UserAvatar from '../user-avatar/UserAvatar';

const drawerWidth = 240;
const isMobile = MobileUtil.size.isMobile();

export default function ({ roomName, roomAction } = {}) {
    const user = useContext(UserContext);
    const [menuOpen, setMenuOpen] = useState(false);
    return (
        <Grid
            container
            alignContent='space-between'
            sx={(theme) => ({
                background: theme.palette.primary.main,
                color: theme.palette.primary.contrastText,
                padding: '4px 14px',
                // This min width helps the flex rows not wrap contents at small screen widths
                minWidth: `${drawerWidth - 10}px`
            })}>
            <Grid item xs sx={{ minWidth: `${drawerWidth - 10}px` }}>
                <Grid container alignItems='center' wrap='nowrap' sx={{ gap: { xs: 0.5, sm: 1 } }}>
                    <IconButton
                        color='inherit'
                        aria-label='open drawer'
                        onClick={() => setMenuOpen(!menuOpen)}
                        edge='start'
                        sx={(theme) => ({
                            marginRight: 4,
                            color: isMobile ? 'lime' : theme.palette.primary.contrastText
                        })}>
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant='h5'
                        noWrap
                        sx={roomName ? { display: { xs: 'none', sm: 'block' } } : undefined}>
                        <Link to='/home' style={{ color: 'unset', textDecoration: 'unset' }}>
                            VYU1
                        </Link>
                    </Typography>
                    {roomName ? (
                        <>
                            <ArrowForwardIosIcon sx={{ ml: 1, fontSize: '1.2rem', opacity: 1, display: { xs: 'none', sm: 'inline-block' } }} />
                            <Typography
                                variant='h6'
                                noWrap
                                sx={{ ml: { xs: 0, sm: 1 }, fontWeight: 'bolder', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {roomName}
                            </Typography>
                        </>
                    ) : null}
                </Grid>
            </Grid>
            <Grid item xs='auto'>
                <Grid container alignItems='center' justifyContent='flex-end' wrap='nowrap' sx={{ gap: { xs: 0.5, sm: 1 } }}>
                    {roomAction ? (
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {roomAction}
                        </Box>
                    ) : null}
                    <Typography
                        variant='h6'
                        sx={(theme) => ({
                            fontWeight: 100,
                            marginRight: '1em',
                            [theme.breakpoints.up('xs')]: {
                                display: 'none'
                            },
                            [theme.breakpoints.up('md')]: {
                                display: 'flex'
                            }
                        })}>
                        {user.fullName}
                    </Typography>
                    <UserAvatar
                        name={user.fullName}
                        src={user.photoURL}
                        sx={{ fontSize: '1.1rem', paddingTop: '3px' }}
                    />
                </Grid>
            </Grid>
            <AppMenu menuOpen={menuOpen} onClose={() => setMenuOpen(!menuOpen)} />
        </Grid>
    );
}
